import React from "react";
import { Box, Tooltip, Typography } from "@material-ui/core";
import useStyles from "./styles";
import UserProfileWidget from "Components/widgets/UserProfileWidget";

const UserListPopOver = ({ userList }) => {
  const classes = useStyles();
  return (
    <Box>
      {userList?.map((user) => {
        return (
          <Box
            display="flex"
            className={`${classes.peopleList} ${
              user?.isNewHighlight ? classes.newUser : ""
            }`}
            alignItems="center"
          >
            <UserProfileWidget
              firstName={user?.firstName}
              lastName={user?.lastName}
              url={user?.profileImage?.fileName}
              status={user?.status}
            />
            <Box width="85%" textAlign="left">
              <Box display={"block"}>
                <Tooltip title={`${user?.firstName} ${user?.lastName}`}>
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body2"
                      noWrap="true"
                      className="font-12"
                    >
                      <span className={`${classes.userName} truncate-txt`}>
                        {user?.firstName} {user?.lastName}
                      </span>{" "}
                    </Typography>
                    <span className="font-12 f-light-gray">
                      {user?.status === "PENDING" ? " (Pending)" : ""}
                    </span>
                  </Box>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default UserListPopOver;
